<template>
    
    <svg width="43" height="37" viewBox="0 0 43 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse opacity="0.9" rx="21.1082" ry="18.4697" transform="matrix(-1 0 0 1 21.3918 18.4697)" :fill="color"/>
</svg>

</template>

<script>
export default {
	name: 'left_knee_f',

	props: {
		// Color or hex code
		color: {
			type: String
		}
	}
}
</script>